import React from 'react';
import Favourite from './../../../../components/Icons/favourite/favourite';
import FavouriteSelected from './../../../../components/Icons/favouriteSelected/likedAlready'
import {deleteComment, likeComment, redirectToSignIn, unlikeComment} from './../../../../redux/actions';
import {connect} from 'react-redux';
import helpers from './../../../../components/utils/helper';
import MoreOptionsIcon from './../../../../components/Icons/moreOptions/moreOptions';
import MoreOptionsModal from './../moreOptionModal/moreOptionsModal';
import DeleteConfirmation from './../DeleteConfirmation/deleteConfirmation';
import {TertiaryLink} from '@sfly/uig-button';
import TooltipDropdownMenu from '@sfly/uig-tooltip-dropdown-menu';
import likesCommentOmnitureCalls from './../../../../redux/utils/likeCommentOmnitureCalls';

class Comment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showMoreOptionsModal: false,
            showDeleteConformation: false,
            showMore: true,
            showToolTip: false,
            currentModalOpenedFor: null,
            calledBefore: true
        }
    }

    componentDidMount() {
        window.addEventListener('click', (event) => {

            var value = this.hasSomeParentTheClass(event.target, "more-options-container");
            if (!value
                && event.target.classList[0] != 'uig-svg-icon') {
                this.props.onClickMore({});
            }
        });

        this.checkPendingActions();

        // window.addEventListener('keypress', (event) => {
        //     console.log('event-->', event);
        // })
    }

    // checks pending Likes
    checkPendingActions = () => {
        const commnetId = helpers.getLocalStorageByKey('commentId');
        if (this.props.user.userId && this.state.calledBefore && commnetId === this.props.comment.id) {
            this.setState({
                calledBefore: false
            });

            this.likeComment();
        }
        helpers.removeLocalStorage(commnetId);
    }

    hasSomeParentTheClass = (element, classname) => {
        if (element.className && typeof element.className.split == 'function' && element.className.split(' ').indexOf(classname) >= 0) return true;
        return element.parentNode && this.hasSomeParentTheClass(element.parentNode, classname);
    }

    // Toggles the value of showMoreOptions
    showHideMoreOptionsModal = () => {
        const {showMoreOptionsModal} = this.state;
        if (this.props.comment.id !== this.props.moreOptionComment.id) {
            this.props.onClickMore(this.props.comment);
        } else {
            this.props.onClickMore({});
        }


        this.setState({
            showMoreOptionsModal: !showMoreOptionsModal,
            currentModalOpenedFor: this.props.comment.id
        });

    }

    // decide if user should call like/unlike api
    likeOrUnline = () => {
        if (!this.props.user.userId) {
            helpers.preservePendingCalls({
                commentId: this.props.comment.id,
                totalComments: this.props.comments.comments.length
            });

            this.props.redirectToSignIn();
            return;
        }

        if (this.checkIfAlreadyLiked()) {
            this.unlikeComment();
        } else {
            this.likeComment();
        }
    }

    // Calls like comment Action
    likeComment = () => {
        const {email, family_name, given_name} = this.props.user;
        this.props.likeComment(this.props.comment.id,
            {
                userId: this.props.user.userId,
                email,
                family_name,
                given_name

            },
            this.props.originalSharedProjectGuid);
    }

    // Calls unlike comment Action
    unlikeComment = () => {
        const {likes, id} = this.props.comment;
        const {userId} = this.props.user;
        this.props.unlikeComment(id,
            this.getLikeId(likes.users, userId),
            userId,
            this.props.originalSharedProjectGuid
        )
    }

    // Gets the like Id of given user
    getLikeId = (users, userId) => {
        for (var i = 0; i < users.length; i++) {
            if (users[i].userId === userId) {
                return users[i].id;
            }
        }
    }

    // checks if user has already liked the comment
    checkIfAlreadyLiked = () => {
        if (this.props.comment.likes) {
            return helpers.isProjectLikedByMe(this.props.comment.likes.users, this.props.user.userId);
        }
        return false;
    }

    /**
     * @params { string } type
     * sets the state for displaying delete modal
     */
    onClickMoreOption = (type) => {
        if (type === 'delete') {
            this.setState({
                showDeleteConformation: true,
                showMoreOptionsModal: false
            });
            likesCommentOmnitureCalls.callOmniture('share-product:delete comment');

        } else if (type === 'edit') {
            this.setState({
                showEdit: true,
                showMoreOptionsModal: false
            });
            this.props.onEdit(true, this.props.comment);
            likesCommentOmnitureCalls.callOmniture('share-product:edit comment');
        }
        this.props.onClickMore({});
    }
    /**
     * @Params { String } action
     * Based on action passed this function sets state of the component.
     */
    onAction = (action) => {

        switch (action) {
            case 'close':
            case 'cancel':
                this.setState({
                    showDeleteConformation: false
                });
                break;
            case 'delete':
                this.deleteComment();
                break;

            default:
        }
    }

    /**
     * function calls the delete comment service
     */
    deleteComment = () => {
        const {id} = this.props.comment;
        const {userId} = this.props.user;
        this.props.deleteComment(id, userId, this.props.originalSharedProjectGuid)
        this.setState({
            showDeleteConformation: false,
            showMoreOptionsModal: false
        })
    }

    isDateValid(dateStr) {
        return !isNaN(new Date(dateStr));
    }

    /**
     * @param {Date Object} date
     * Returns string in the readable format of date
     */
    getDateInFormat(date) {
        let now = new Date(date);

        if (!this.isDateValid(date)) {
            // var s = '2010-11-12T06:14:15Z';
            var s = date;

            // Parse YYYY-MM-DDTHH:mm:ss as UTC
            function parseUTC(s) {
                var b = s.split(/\D/);
                return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5]))
            }

            now = parseUTC(s);
        }
        return now.toLocaleString('default', { month: 'long', day: "numeric", year: "numeric" });
    }

    /**
     * identifies if comment is done by logged In user
     */
    isMyComment = () => {
        const {userId} = this.props.user;
        return this.props.comment.commentCreatedBy === userId || userId === this.props.userId;
    }

    /**
     *
     * @param {Boolean} value
     */
    setReadMore(value) {
        this.setState({
            showMore: value
        });
    }

    renderWithReadMore = (commentText, maxLength) => {
        if (this.state.showMore) {
            commentText = commentText.substring(0, maxLength);
        }
        return (<React.Fragment>
            {
                commentText
            }
            {
                this.state.showMore ?
                    <TertiaryLink onClick={this.setReadMore.bind(this, false)}>Read More</TertiaryLink>
                    :
                    <TertiaryLink onClick={this.setReadMore.bind(this, true)}>Read less</TertiaryLink>
            }
        </React.Fragment>)
    }

    getMaxLength() {
        if (window.innerWidth > 1500) {
            return 500;
        } else if (window.innerWidth > 1100) {
            return 350;
        } else if (window.innerWidth > 800) {
            return 300;
        } else if (window.innerWidth > 600) {
            return 200;
        } else if (window.innerWidth > 374) {
            return 150;
        } else {
            return 120;
        }
    }

    showCommentText = (commentText) => {
        let maxLength = this.getMaxLength();
        return commentText.length < maxLength ? commentText : this.renderWithReadMore(commentText, maxLength);
    }

    renderContents() {
        let users = [];
        users = this.props.comment && this.props.comment.likes ? this.props.comment.likes.users : [];
        return <div>
            {
                users.map((user, index) => {
                    if (index < 10) {
                        return (<li key={index}> {user.userName + ((index < users.length - 1 ? "" : ""))}</li>)

                    } else if (index === 10) {
                        return (<li key={index}>{users.length - 10} More</li>)

                    }
                })
            }
        </div>;
    }

    shouldShowToolTip = () => {
        return (!helpers.isMobile() && this.props.comment && this.props.comment.likes && this.props.comment.likes.likesCount > 0 && this.state.showToolTip);
    }

    onMouseEnter = () => {
        this.setState({
            showToolTip: true
        });
    }

    onMouseLeave = () => {
        this.setState({
            showToolTip: false
        });
    }

    likeCount = () => {
        return this.props.comment && this.props.comment.likes ? (this.props.comment.likes.likesCount == 0 ? "" : this.props.comment.likes.likesCount) + " " : "";
    }

    showMoreOptionsModalLogic = () => {
        // console.log('this.state.showMoreOptionsModal-->', this.state.showMoreOptionsModal);
        return (this.props.comment.id === this.props.moreOptionComment.id);
    }


    render() {
        var userId = this.props.user.userId;
        const {commentText, commentCreatorName, dateCreated} = this.props.comment;
        let {style} = this.props;
        if (!style) {
            style = {};
        }
        const {showMoreOptionsModal, showDeleteConformation, showEdit} = this.state;
        let likedAlready = this.checkIfAlreadyLiked();
        return (<div className="comment-container" style={style}>
            <div className="commentor-name">
                {commentCreatorName}
                <span className="date-name-seperator">.</span>
                {this.getDateInFormat(dateCreated)}
            </div>
            <div className="comment-text">
                {this.showCommentText(commentText)}
            </div>
            <div className="icon-container">
                <div>
                    <div className="icon-text-container"

                         onMouseEnter={this.onMouseEnter}
                         onMouseLeave={this.onMouseLeave}>
                        {
                            likedAlready ?
                                <div onClick={this.likeOrUnline}>
                                    <FavouriteSelected/>
                                </div>
                                :
                                <div onClick={this.likeOrUnline}>
                                    <Favourite height={10.37} width={12}/>
                                </div>
                        }
                        {
                            this.shouldShowToolTip() &&
                            <TooltipDropdownMenu>
                                <ul>
                                    {
                                        this.renderContents()
                                    }
                                </ul>
                            </TooltipDropdownMenu>
                        }
                        <p>{this.likeCount()} {this.likeCount() > 1 ? 'Likes' : 'Like'}</p>
                    </div>
                </div>
                {
                    this.isMyComment() &&
                    <div onClick={this.showHideMoreOptionsModal} className="more-option-container">
                        <MoreOptionsIcon/>
                    </div>
                }
            </div>
            {
                this.showMoreOptionsModalLogic() &&
                <MoreOptionsModal
                    onClickMoreOption={this.onClickMoreOption}
                    showEdit={this.props.comment.commentCreatedBy === userId}/>
            }
            {
                showDeleteConformation && <DeleteConfirmation onAction={this.onAction}/>
            }


        </div>)
    }
}

const mapPropsToState = state => {
    return {
        user: state.user,
        comments: state.comments
    }
}

const dispatchPropsToState = {
    likeComment,
    unlikeComment,
    deleteComment,
    redirectToSignIn
}

export default connect(mapPropsToState, dispatchPropsToState)(Comment);